var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isReady)?_c('AudienceDetailsEditor',{ref:"audienceDetailsEditorRef",attrs:{"audienceDetails":_vm.audienceDetails,"draftAudienceDetails":_vm.audienceDetails},on:{"on-save":_vm.handleSave,"on-save-publish":_vm.handleSavePublish}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }